require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./historique-1-1-5-6.json") })
        }
      }, "path---historique-1-1-5-6");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---historique-1-1-5-6!./.cache/json/historique-1-1-5-6.json
// module id = 459
// module chunks = 231608221292675